var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRolesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 84.454v343.093h512V84.454H0zm496.165 327.257H15.835V147.794H382.68v-15.835H15.835v-31.67h480.33v311.422z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.289 179.464v110.845h58.062v-52.784h26.392v31.67h58.062v-31.67h42.724a63.56 63.56 0 0 0-.497 7.918c0 36.382 29.598 65.979 65.979 65.979s65.979-29.598 65.979-65.979-29.598-65.979-65.979-65.979H100.289zm300.866 65.979c0 27.649-22.495 50.144-50.144 50.144-27.649 0-50.144-22.495-50.144-50.144 0-4.439.635-8.943 1.941-13.766l2.704-9.987H226.97v31.67h-26.392v-31.67h-58.062v52.784h-26.392v-79.175H351.01c27.649 0 50.145 22.495 50.145 50.144z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M332.536 245.443c0-10.186 8.288-18.474 18.474-18.474v-15.835c-18.919 0-34.309 15.391-34.309 34.309s15.391 34.309 34.309 34.309c18.919 0 34.309-15.391 34.309-34.309h-15.835c0 10.186-8.288 18.474-18.474 18.474-10.186.001-18.474-8.288-18.474-18.474zm71.258-113.484h26.392v15.835h-26.392zm42.227 0h26.392v15.835h-26.392zm0 242.804h26.392v15.835h-26.392zm0-31.67h26.392v15.835h-26.392zm-36.949 31.67h26.392v15.835h-26.392zM36.948 390.598h100.289v-58.062H36.948v58.062zm15.836-42.227h68.619v26.392H52.784v-26.392zm108.206-15.835h168.907v15.835H160.99zm0 42.227h31.67v15.835h-31.67zm42.227 0h31.67v15.835h-31.67z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesIcon);
export default __webpack_public_path__ + "static/media/roles-icon.a5a7bac88faa9a61e205b86714d089da.svg";
export { ForwardRef as ReactComponent };